import React from 'react';

import {useTranslation} from 'react-i18next';

import {PageHeader} from '@/widgets/PageHeader';
import {Period} from '@/widgets/Period';
import {Wrapper} from '@pages/OfficerSummary/styled';
import {ManagementSummary} from '@pages/OfficerSummary/ui/ManagementSummary';
import {Page} from '@shared/ui/Page';

export const OfficerSummaryPage = () => {
    const {t} = useTranslation();

    return (
        <Page>
            <Wrapper>
                <PageHeader title={t('page_main.title')}>
                    <Period requireMonth={false} />
                </PageHeader>
                <ManagementSummary />
            </Wrapper>
        </Page>
    );
};
